import React from "react";
import BaseHeader from "../../sisu/layout/BaseHeader.sisu";

const NeoHeader = (props) => {
  return (<BaseHeader custom="sd-header" {...props}/>);
};

export default NeoHeader;